export default {

}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/components/resources/methods.js